import {CALL_API} from 'redux-api-middleware';
import {
  API_AWARDREC_PUT_REQUEST,
  API_AWARDREC_PUT_SUCCESS,
  API_AWARDREC_PUT_FAILURE,
} from 'common/types';

import {commonJwtHeader} from 'common/utils';
import {ENDPOINT_DYNAMIC_DATA} from 'common/endpoints';

export default {
  updateAwardRecommendationByGrant: (token, entityId, payload) => {
    console.log('updateAwardRecommendationByGrant', entityId);
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}entities/${entityId}/budget-summary`,
        headers: commonJwtHeader(),
        body: payload,
        method: 'PUT',
        types: [
          API_AWARDREC_PUT_REQUEST,
          API_AWARDREC_PUT_SUCCESS,
          API_AWARDREC_PUT_FAILURE,
        ],
      },
    };
  },
};
